import NiceModal from '@ebay/nice-modal-react';

// Import components
import { SubscriptionCanceledModal, LastPaymentModal } from 'components/views/offer_configurator/components/common/modals';

// Import context
import { useConfiguratorContext } from 'components/context/configurator/ConfiguratorProvider';

// Import types
import type { PacketWithPriceAndChannels } from 'types/views/configurator';

export const useSelectPacket = (callback: (packet: PacketWithPriceAndChannels) => void) => {
	const { subscription, lastPayment: payment } = useConfiguratorContext();

	const onSelect = (packet: PacketWithPriceAndChannels) => {
		const setPacket = callback.bind(null, packet);

		if (subscription?.isCanceled) {
			NiceModal.show(SubscriptionCanceledModal, { expires_on: subscription.expires_on });
		} else if (payment) {
			NiceModal.show(LastPaymentModal, { payment, setPacket });
		} else {
			setPacket();
		}
	};

	return { onSelect };
};
